import { ModuleNames } from '../../src/constants/componentNames.constants'

export default (data: any) => ({
  name: data?.fields?.name,
  title: data?.fields?.title
    ? {
        title: data.fields.title,
      }
    : null,
  body: data?.fields?.body ? data.fields.body : null,
  __typename: ModuleNames.TOPIC_FAQ,
})
